import { H6Regular, useThemeColors, XStack } from 'smoothie';

import Logo from '../../../assets/images/logos/logo-new.svg';
import { TabHeaderButtons } from './TabHeaderButtons';

export const LimitedAccessPageHeader = ({
    headerTitle,
}: {
    headerTitle: string;
}) => {
    const { getColor } = useThemeColors();

    return (
        <XStack
            backgroundColor="$gray100"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            paddingHorizontal={16}
            paddingVertical={4}
            $sm={{
                paddingHorizontal: 32,
                paddingVertical: 24,
            }}
        >
            <XStack gap={0} alignItems="center">
                {/* small adjustment for vertical alignment with title */}
                <XStack marginTop={-2}>
                    <Logo height={20} color={getColor('$black')} />
                </XStack>
                <H6Regular>{headerTitle}</H6Regular>
            </XStack>
            <TabHeaderButtons />
        </XStack>
    );
};
